import { MessageCircle, Link2 } from "lucide-react";
import { toast } from "sonner";
import { formatPrice, trackEvent } from "@/lib/api";

export const ShareButtons = ({ product }) => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/api/share/product/${product.id}`;
  const text = `${product.name} — ${formatPrice(product.price)} (${product.discount_pct}% off) · Free delivery · COD available`;

  const copy = async () => {
    trackEvent("share", { product_id: product.id, path: "copy" });
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied — paste it in WhatsApp or Facebook");
    } catch {
      toast.error("Could not copy link");
    }
  };

  const btn = "flex-1 flex items-center justify-center gap-2 h-10 rounded-sm text-sm font-semibold border transition-colors";
  return (
    <div className="flex gap-2 mt-3" data-testid="share-buttons">
      <a
        href={`https://wa.me/?text=${encodeURIComponent(`${text}\n${url}`)}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackEvent("share", { product_id: product.id, path: "whatsapp" })}
        className={`${btn} border-[#25D366] text-[#128C7E] hover:bg-[#e9fbf0]`}
        data-testid="share-whatsapp-btn"
      >
        <MessageCircle className="w-4 h-4" /> Share on WhatsApp
      </a>
      <button onClick={copy} className={`${btn} border-[#e0e0e0] text-[#212121] hover:border-[#C62828] hover:text-[#C62828]`} data-testid="share-copy-link-btn">
        <Link2 className="w-4 h-4" /> Copy Link
      </button>
    </div>
  );
};
